import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M796.862588,1332.48 C745.587294,1596.87529 679.290824,1787.52 494.067294,1920 C436.806118,1520.52706 578.095529,1220.55529 643.601412,901.835294 C531.789647,716.724706 657.041412,344.018824 892.636706,435.727059 C1182.55671,548.781176 662.462588,1097.11059 1025.68141,1169.05412 C1404.93788,1244.04706 1540.69318,596.894118 1305.66259,361.750588 C965.935529,22.2494118 289.079059,310.136471 394.453176,791.491765 C436.919059,985.524706 292.467294,1040.75294 292.467294,1040.75294 C175.460235,993.317647 164.279059,829.101176 170.264941,668.837647 C183.704941,300.310588 506.490824,42.24 830.293176,6.43764706 C1239.81788,-38.7388235 1624.15671,154.503529 1677.12612,533.985882 C1736.98494,962.145882 1500.14729,1454.00471 1062.16141,1420.57412 C943.573176,1411.53882 796.862588,1332.48 796.862588,1332.48",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconPinterestSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconPinterestSolid, _Component);

  var _super = _createSuper(IconPinterestSolid);

  function IconPinterestSolid() {
    _classCallCheck(this, IconPinterestSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconPinterestSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconPinterest",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconPinterestSolid.displayName = "IconPinterestSolid";
  return IconPinterestSolid;
}(Component);

IconPinterestSolid.glyphName = 'pinterest';
IconPinterestSolid.variant = 'Solid';
IconPinterestSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconPinterestSolid;
export { IconPinterestSolid };